import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, DownloadIcon, MailIcon, MessageCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from '../components/Reveal';
import { Footer } from '../components/Footer';
import { trackPurchase } from '../utils/metaPixel';
const steps = [{
  icon: MailIcon,
  title: 'Revisa tu correo ahora',
  detail: 'Hotmart te envió el acceso a tu cuenta con el Método y los 3 bonos. Si no lo ves, busca en Spam o Promociones y marca el mensaje como "No es spam".'
}, {
  icon: DownloadIcon,
  title: 'Descarga el material',
  detail: 'Entra a tu cuenta de Hotmart, abre el producto y descarga el Método de Vaciado Biológico junto con los tres bonos. El acceso es tuyo para siempre.'
}, {
  icon: CheckCircle2Icon,
  title: 'Empieza por la Fase 1',
  detail: 'No saltes a la fase de ataque. Los primeros 7 días preparan tu sistema digestivo y son los que hacen que el resto del protocolo funcione sin malestar.'
}];
export function Gracias() {
  useEffect(() => {
    trackPurchase();
  }, []);
  return <div className="w-full bg-cream font-sans text-charcoal" data-id="element-193" data-mp="2l9y884aeqkzf">
      <main data-id="element-194" data-mp="2q298j89288si">
        {/* Confirmation */}
        <section className="w-full bg-forest py-14 sm:py-16" data-id="element-195" data-mp="2q3as614563lu">
          <div className="mx-auto max-w-2xl px-5 text-center sm:px-6" data-id="element-196" data-mp="2u31g7x2aa5mo">
            <motion.div initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex justify-center" data-id="element-197" data-mp="1xe3mmi69sdr3">
              <CheckCircle2Icon className="h-16 w-16 text-gold" strokeWidth={1.4} aria-hidden="true" data-id="element-198" data-mp="26d779ql3517p" />
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 18
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            ease: [0.23, 1, 0.32, 1],
            delay: 0.06
          }} className="mt-5 text-[30px] font-bold leading-[1.08] tracking-tight text-white sm:text-[42px]" data-id="element-199" data-mp="3ht5jg3bk83d5">
              ¡Tu compra está confirmada!
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 18
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            ease: [0.23, 1, 0.32, 1],
            delay: 0.1
          }} className="mx-auto mt-3 max-w-xl text-[17px] leading-relaxed text-white/85" data-id="element-200" data-mp="1wndlza8jvlic">
              Bienvenido a Legado Salud. Tu acceso al Método de Vaciado Biológico y a los 3 bonos ya
              está activo — sigue estos tres pasos para empezar hoy mismo.
            </motion.p>
          </div>
        </section>

        {/* Next steps */}
        <section className="w-full py-14" data-id="element-201" data-mp="l99tk8hm25fe">
          <div className="mx-auto max-w-3xl px-5 sm:px-6" data-id="element-202" data-mp="l88dfplqmsqt">
            <ol className="space-y-4" data-id="element-203" data-mp="gayi5tbo3mv2">
              {steps.map((step, i) => <Reveal as="li" key={step.title} delay={i * 0.08} data-id="element-204" data-mp="2rxs8vbziy0ej" data-mpi={i}>
                  <article className="flex gap-4 rounded-xl bg-white p-5 shadow-sm sm:p-6" data-id="element-205" data-mp="2rwh53c62wsnf">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-forest" data-id="element-206" data-mp="2wq380cmfxi61">
                      <step.icon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-207" data-mp="2iv0ub3bcqoio" />
                    </span>
                    <div data-id="element-208" data-mp="2mwcntjxcjtw5">
                      <h2 className="text-[16px] font-bold tracking-tight text-forest" data-id="element-209" data-mp="3aojh2a7rzkrc">
                        <span className="mr-2 font-mono text-gold" data-id="element-210" data-mp="3fnea04zgipp6">{i + 1}.</span>
                        {step.title}
                      </h2>
                      <p className="mt-1.5 text-[15px] leading-relaxed text-warmgray" data-id="element-211" data-mp="31mtov262khsi">
                        {step.detail}
                      </p>
                    </div>
                  </article>
                </Reveal>)}
            </ol>

            {/* Support + guarantee */}
            <Reveal delay={0.1} data-id="element-212" data-mp="1v8atu6enj206">
              <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-213" data-mp="1v56j0q6ol80j">
                <div className="rounded-xl bg-mint p-5" data-id="element-214" data-mp="2ahy2kslv9d32">
                  <h3 className="flex items-center gap-2 text-[15px] font-bold tracking-tight text-forest" data-id="element-215" data-mp="25qprls4w1jns">
                    <MessageCircleIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-216" data-mp="20qv3txgeta6y" />
                    ¿No te llegó el acceso?
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-charcoal/80" data-id="element-217" data-mp="1wnonty3hw4na">
                    Escríbenos a{' '}
                    <a href="mailto:soporte@legadosalud.com" className="font-semibold text-forest underline underline-offset-4" data-id="element-218" data-mp="2ogxqfy1k1ny6">
                      soporte.legadosalud@gmail.com
                    </a>{' '}
                    con el correo que usaste al comprar y lo resolvemos el mismo día.
                  </p>
                </div>

                <div className="rounded-xl bg-mint p-5" data-id="element-219" data-mp="1918dcoruapah">
                  <h3 className="flex items-center gap-2 text-[15px] font-bold tracking-tight text-forest" data-id="element-220" data-mp="1413w2wj3xqj7">
                    <ShieldCheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-221" data-mp="3fopj5s8dy5u0" />
                    Garantía de 07 días
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-charcoal/80" data-id="element-222" data-mp="3ko24g8jlz4uh">
                    Pruébalo sin riesgo. Si no sientes la diferencia, un solo email basta para
                    recibir el 100% de tu dinero de vuelta.
                  </p>
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.14} data-id="element-223" data-mp="2bni565foe8j">
              <p className="mt-8 text-center text-sm italic leading-relaxed text-warmgray" data-id="element-224" data-mp="784iqzttkl2i">
                Un consejo antes de empezar: agenda tus 21 días en el calendario hoy. Quienes fijan
                la fecha de inicio son los que terminan el protocolo.
              </p>
            </Reveal>
          </div>
        </section>
      </main>

      <Footer data-id="element-225" data-mp="2e0ojcpkno1ov" />
    </div>;
}